import React from 'react'
import MaterialSymbol from '../material-symbol'

const PeopleOutline = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="people_outline" {...props} />
))

PeopleOutline.displayName = 'PeopleOutline'

export default PeopleOutline
